import { createFileRoute } from '@tanstack/react-router';

import { AdminCinemaPage } from '@/components/admin/cinema-page';
import { adminHead } from '@/lib/seo';
import {
    adminCinemaStatsFn,
    adminListCinemaScreeningsFn,
} from '@/server/functions/admin';

export const Route = createFileRoute('/_admin/admin/cinema')({
    component: CinemaRoute,
    head: () => adminHead('קולנוע', '/admin/cinema'),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: async () => {
        const [initial, stats] = await Promise.all([
            adminListCinemaScreeningsFn({
                data: { when: 'upcoming', limit: 50 },
            }),
            adminCinemaStatsFn(),
        ]);
        return { initial, stats };
    },
});

function CinemaRoute() {
    const { initial, stats } = Route.useLoaderData();
    return <AdminCinemaPage initial={initial} stats={stats} />;
}
